import React from 'react';
import { useSelector } from "react-redux";
import moment from 'moment';

import '../styles/traderHistory.css'
const TradeHistory = () => {
  const { account } = useSelector((state) => state.accounts);
  return (
    <>
      <div className="tradehist">
        <div className="cont">
          <h2>Trade History</h2>
          <ul>
            <li>
              <h4>Amount</h4>
              <h4>Asset</h4>
              <h4>Asset Type</h4>
              <h4>Stop Loss</h4>
              <h4>Returns</h4>
              <h4>Status</h4>
              <h4>Actions</h4>
              <h4>Type</h4>
              <h4>Duration</h4>
              <h4>Date</h4>
            </li>
            {
              account?.trades?.map((trade, index) => (
                <li key={index}>
                  <h4>{trade?.amount}</h4>
                  <h4>{trade?.assets}</h4>
                  <h4>{trade?.assetType}</h4>
                  <h4>{trade?.stopLoss}</h4>
                  <h4>{trade?.returns}</h4>
                  <h4>{trade?.status}</h4>
                  <h4>{trade?.action}</h4>
                  <h4>{trade?.type}</h4>
                  <h4>{trade?.duration}</h4>
                  <h4>{moment(trade?.date).fromNow()}</h4>
                </li>
              ))
            }
          </ul>
          <p>No more trades available</p>
        </div>
      </div>
    </>
  )
}

export default TradeHistory